export default {
  "LocationSummary.Title": "位置情報利用の管理",
  "LocationSummary.Text1":
    "ご自身の位置情報をドコモおよびNTTドコモビジネス株式会社が利用することについて、同意／不同意のご選択ができます",
}
